import isEmpty from 'lodash/isEmpty';
import { resultsPresentation } from 'modules/results/derivations';
import { formatAltitude, formatDistance } from 'modules/results/utils';
import * as React from 'react';
import styled from 'styled-components';

import { Cell } from 'src/modules/racersTable/components';
import { CELL_SIZES } from 'src/modules/racersTable/constants';
import { RightSideColumnsType } from 'src/modules/racersTable/types';
import { getCellSizes } from 'src/modules/racersTable/utils';

import { classesStore, wavesStore, distancesStore, goalsStore } from '../../stores';

import { LResult } from '../../types';
import { CheckpointArrow } from '../Checkpoint';
import { PresentResult } from '../PresentResult';
import { RowWrap } from './RowWrap';

type Props = {
  columnsActive: RightSideColumnsType;
  value: LResult;
  checkpointId: number | nil;
  distanceId: number | nil;
};

type CellType = {
  condition?: boolean;
  value?: string | React.ReactNode;
  minWidth?: string;
  weight?: 'medium' | 'bold';
};

const Wrapper = styled(RowWrap)<{ sizes: string }>`
  .grid-wrap {
    justify-content: flex-end;
    align-items: center;
    grid-template-columns: ${(props) => props.sizes};
    gap: 32px;

    padding: 20px 40px 20px 32px;
    height: 132px;
    width: 100%;
  }

  &:nth-child(even) {
    background-color: ${(props) => props.theme.main.colors.clay7};
  }
`;

export const RightSideTeamRow = (props: Props) => {
  const { columnsActive, value, checkpointId, distanceId } = props;
  const sizes = getCellSizes(columnsActive);
  const distanceModel = distancesStore.find(+distanceId!);
  const place = resultsPresentation.generatePlace(value, distanceId!, checkpointId);

  if (!value.team || !distanceModel) return null;

  const classModel = classesStore.find(+value.team.class_id!);
  const waveModel = wavesStore.find(+value.team.wave_id!);

  const CheckpointButton = !isEmpty(distanceModel.checkpoints) ? <CheckpointArrow recordId={value.team_id} /> : null;

  const goalModel = goalsStore.findByDistance(+distanceId!);
  const distanceLogged = value.distance_logged as any;
  const distanceLength = goalModel?.isGoalType('distance') ? formatDistance(distanceLogged) : formatAltitude(distanceLogged);

  return (
    <Wrapper sizes={sizes} checkpointId={checkpointId} distanceId={Number(distanceId)} height={132} value={value} isRightSide place={place}>
      <Cell name='club' columnsActive={columnsActive} minWidth={CELL_SIZES[0].minWidth} />
      <Cell name='squad' columnsActive={columnsActive} minWidth={CELL_SIZES[1].minWidth} value={value.team.name} />
      <Cell name='class' columnsActive={columnsActive} minWidth={CELL_SIZES[2].minWidth} value={classModel?.value.title} />
      <Cell name='wave' columnsActive={columnsActive} minWidth={CELL_SIZES[3].minWidth} value={waveModel?.value.name} />
      <Cell
        name='time'
        columnsActive={columnsActive}
        minWidth={CELL_SIZES[4].minWidth}
        weight='bold'
        value={<PresentResult.FinishResult result={value} checkpointId={checkpointId} distance={distanceModel} />}
      />
      <Cell
        name='diff'
        columnsActive={columnsActive}
        minWidth={CELL_SIZES[5].minWidth}
        value={<PresentResult.LeaderTime result={value} checkpointId={checkpointId} distanceId={Number(distanceId)} />}
      />
      <Cell name='goalDistance' value={distanceLength} columnsActive={columnsActive} />
      <Cell name='tracker' columnsActive={columnsActive} minWidth={CELL_SIZES[6].minWidth} />
      <Cell name='checkpoint' columnsActive={columnsActive} minWidth={CELL_SIZES[7].minWidth} value={CheckpointButton} />
    </Wrapper>
  );
};
